import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../Context/auth";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "../../Context/ThemeContext";
import { format } from "timeago.js";

const AdminDashboard = () => {
  const { darkMode, toggleTheme } = useTheme();
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState([]);
  const [latestUsers, setLatestUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  // Add this with your other state declarations
  const [userAdDetails, setUserAdDetails] = useState(null);
  const [adSearchEmail, setAdSearchEmail] = useState("");
  const [editingUser, setEditingUser] = useState(null);
  const [depositAccounts, setDepositAccounts] = useState([]);
  const [deposits, setDeposits] = useState([]);
  const [filteredDeposits, setFilteredDeposits] = useState([]);
  const [depositSearchTerm, setDepositSearchTerm] = useState("");
  const [depositsCurrentPage, setDepositsCurrentPage] = useState(1);
  const [depositsPerPage] = useState(10);
  // Add these to your existing state declarations
  const [cashouts, setCashouts] = useState([]);
  const [filteredCashouts, setFilteredCashouts] = useState([]);
  const [cashoutSearchTerm, setCashoutSearchTerm] = useState("");
  const [cashoutsCurrentPage, setCashoutsCurrentPage] = useState(1);
  const [cashoutsPerPage] = useState(10);
  const [remarks, setRemarks] = useState();
  const [newDepositAccount, setNewDepositAccount] = useState({
    account: "",
    accountNumber: "",
  });
  const [investmentPlans, setInvestmentPlans] = useState([]);
  const [editingAccount, setEditingAccount] = useState(null);

  const [newPlan, setNewPlan] = useState({
    Planename: "",
    price: "",
    commissionRate: "",
  });
  const [editingPlan, setEditingPlan] = useState(null);
  // Add this state near your other state declarations
  const [searchEmail, setSearchEmail] = useState("");
  const [searchedUser, setSearchedUser] = useState(null);
  const [referralTree, setReferralTree] = useState([]);
  const [advances, setAdvances] = useState([]);
  const [filteredAdvances, setFilteredAdvances] = useState([]);
  const [advanceSearchTerm, setAdvanceSearchTerm] = useState("");
  const [advancesCurrentPage, setAdvancesCurrentPage] = useState(1);
  const [advancesPerPage] = useState(10);
  const handleCashoutSearch = (e) => {
    const term = e.target.value;
    setCashoutSearchTerm(term);

    if (term === "") {
      setFilteredCashouts(cashouts);
      return;
    }
    // Fetch advances function

    const filtered = cashouts.filter(
      (cashout) =>
        cashout?.accountNumber?.toLowerCase().includes(term.toLowerCase()) ||
        cashout?.user?.email?.toLowerCase().includes(term.toLowerCase()) ||
        cashout?.status?.toLowerCase().includes(term.toLowerCase())
    );

    setFilteredCashouts(filtered);
    setCashoutsCurrentPage(1);
  };
  const fetchCashouts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/cashout/admin/all",
        {
          headers: {
            "Cache-Control": "no-cache",
            Authorization: `Bearer ${auth?.token || ""}`,
          },
        }
      );

      console.log("Cashouts data:", data);

      // Handle both array and object response formats
      const cashoutsData = Array.isArray(data) ? data : data?.cashouts || [];

      // Sort to show pending cashouts first
      const sortedCashouts = [...cashoutsData].sort((a, b) => {
        if (a.status === "pending" && b.status !== "pending") return -1;
        if (a.status !== "pending" && b.status === "pending") return 1;
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      setCashouts(sortedCashouts);
      setFilteredCashouts(sortedCashouts);
    } catch (error) {
      toast.error("Failed to fetch cashouts");
      console.error("Error fetching cashouts:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCashouts(); // Add this line
  }, []);
  const handleUpdateCashoutStatus = async (cashoutId, newStatus) => {
    try {
      const { data } = await axios.put(
        `https://bioopay-full-backend.onrender.com/api/v1/cashout/admin/update/${cashoutId}`,
        { status: newStatus, remarks }
      );
      toast.success(`Cashout ${newStatus} successfully`);
      setRemarks(""); // Clear remarks after update
      fetchCashouts(); // Refresh the list
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update cashout status"
      );
      console.error("Error updating cashout status:", error);
    }
  };
  // Add this function to handle the search
  const handleSearchByEmail = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        "https://bioopay-full-backend.onrender.com/api/v1/users/get-refefral-tree-email",
        { email: searchEmail }
      );
      setSearchedUser(data.user);
      setReferralTree(data.referralTree);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to search user");
    } finally {
      setLoading(false);
    }
  };
  // Update advance status
  const handleUpdateAdvanceStatus = async (advanceId, newStatus) => {
    try {
      const { data } = await axios.put(
        `https://bioopay-full-backend.onrender.com/api/v1/advance/admin/update/${advanceId}`,
        { status: newStatus, remarks },
        {
          headers: {
            Authorization: `Bearer ${auth?.token || ""}`,
          },
        }
      );
      toast.success(`Advance request ${newStatus} successfully`);
      fetchAdvances();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update advance request"
      );
      console.error("Error updating advance status:", error);
    }
  };
  // Fetch advance requests
  const fetchAdvances = async () => {
    try {
      setLoading(true);
      console.log("Fetching advances..."); // Debug log
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/advance/admin/all",
        {
          headers: {
            Authorization: `Bearer ${auth?.token || ""}`,
          },
        }
      );
      console.log("Advances data:", data); // Debug log
      const sortedAdvances = [...data.data].sort((a, b) => {
        if (a.status === "pending" && b.status !== "pending") return -1;
        if (a.status !== "pending" && b.status === "pending") return 1;
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      setAdvances(sortedAdvances);
      setFilteredAdvances(sortedAdvances);
    } catch (error) {
      console.error("Error details:", error.response); // More detailed error logging
      toast.error("Failed to fetch advance requests");
      console.error("Error fetching advances:", error);
    } finally {
      setLoading(false);
    }
  };

  // Search advance requests
  const handleAdvanceSearch = (e) => {
    const term = e.target.value;
    setAdvanceSearchTerm(term);

    if (term === "") {
      setFilteredAdvances(advances);
      return;
    }

    const filtered = advances.filter(
      (advance) =>
        advance?.user?.email?.toLowerCase().includes(term.toLowerCase()) ||
        advance?.status?.toLowerCase().includes(term.toLowerCase()) ||
        advance?.teamCategory?.toLowerCase().includes(term.toLowerCase()) ||
        (advance?.adminRemarks &&
          advance.adminRemarks.toLowerCase().includes(term.toLowerCase()))
    );

    setFilteredAdvances(filtered);
    setAdvancesCurrentPage(1);
  };
  const pendingWithdrawals = [
    {
      id: 1,
      userId: 3,
      amount: "$250",
      method: "Bank Transfer",
      date: "2023-08-01",
      status: "Pending",
    },
  ];

  // Safe number formatting
  const formatNumber = (num) => {
    if (num === undefined || num === null) return "0";
    return num.toLocaleString();
  };

  const stats = [
    {
      title: "Total Users",
      value: formatNumber(users.length),
      change: "+12%",
      isPositive: true,
    },
    {
      title: "Total Deposit Accounts",
      value: formatNumber(depositAccounts.length),
      change: "+5%",
      isPositive: true,
    },
    {
      title: "Total Deposits",
      value: formatNumber(deposits.length),
      change: "+8%",
      isPositive: true,
    },
    {
      title: "Pending Deposits",
      value: formatNumber(
        deposits.filter((d) => d.status === "pending").length
      ),
      change: "+3%",
      isPositive: true,
    },

    {
      title: "Pending Withdrawals",
      value: formatNumber(
        cashouts.filter((c) => c.status === "pending").length
      ),
      change: "+12%",
      isPositive: true,
    },
    {
      title: "Pending Advance",
      value: formatNumber(
        advances.filter((d) => d.status === "pending").length
      ),
      change: "+3%",
      isPositive: true,
    },
  ];

  // Fetch all users
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/users/get-all-user"
      );
      setUsers(data?.users || []);
      // Get latest 5 users
      const sortedUsers = [...(data?.users || [])].sort(
        (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
      );
      setLatestUsers(sortedUsers.slice(0, 5));
    } catch (error) {
      toast.error("Failed to fetch users");
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch all investment plans
  const fetchPlans = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/plane/get-plane"
      );
      setInvestmentPlans(data?.data || []);
    } catch (error) {
      toast.error("Failed to fetch investment plans");
      console.error("Error fetching plans:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch deposit accounts
  const fetchDepositAccounts = async () => {
    try {
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/depositeaccount/get-account"
      );
      // Ensure we always set an array, even if the response structure is different
      setDepositAccounts(
        Array.isArray(data) ? data : data?.accounts || data?.data || []
      );
    } catch (error) {
      toast.error("Failed to fetch deposit accounts");
      console.error("Error fetching deposit accounts:", error);
      // Set to empty array on error
      setDepositAccounts([]);
    }
  };
  const fetchUserAdDetails = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        "https://bioopay-full-backend.onrender.com/api/v1/ads/get-user-ads",
        { email: adSearchEmail }
      );

      // Ensure we have a proper response structure
      const formattedData = {
        user: data.user || { name: "N/A", email: adSearchEmail },
        totalAdsWatched: data.totalAdsWatched || 0,
        totalEarningsFromAds: data.totalEarningsFromAds || 0,
        userAds: data.userAds || [], // Ensure this is always an array
      };

      setUserAdDetails(formattedData);
      toast.success("Ad details fetched successfully");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch ad details"
      );
      console.error("Error fetching ad details:", error);
      setUserAdDetails(null);
    } finally {
      setLoading(false);
    }
  };
  const createDepositAccount = async () => {
    try {
      if (!newDepositAccount.account || !newDepositAccount.accountNumber) {
        return toast.error("Please fill all fields");
      }

      const { data } = await axios.post(
        "https://bioopay-full-backend.onrender.com/api/v1/depositeaccount/create-account",
        newDepositAccount
      );
      toast.success("Deposit account created successfully");
      setNewDepositAccount({ account: "", accountNumber: "" });
      // Refresh the accounts list
      await fetchDepositAccounts();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create account");
      console.error("Error creating deposit account:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchPlans();
    fetchDepositAccounts();
    fetchAdvances();
  }, []);

  // Handle input changes for plans
  const handlePlanInputChange = (e) => {
    const { name, value } = e.target;
    if (editingPlan) {
      setEditingPlan({ ...editingPlan, [name]: value });
    } else {
      setNewPlan({ ...newPlan, [name]: value });
    }
  };

  // Handle input changes for user edit
  const handleUserInputChange = (e) => {
    const { name, value } = e.target;
    setEditingUser({ ...editingUser, [name]: value });
  };

  // Create new plan
  const handleAddPlan = async () => {
    try {
      if (!newPlan.Planename || !newPlan.price || !newPlan.commissionRate) {
        return toast.error("Please fill all fields");
      }

      const { data } = await axios.post(
        "https://bioopay-full-backend.onrender.com/api/v1/plane/create-plane",
        newPlan
      );
      toast.success("Plan created successfully");
      setNewPlan({ Planename: "", price: "", commissionRate: "" });
      fetchPlans();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create plan");
      console.error("Error creating plan:", error);
    }
  };

  // Update existing plan
  const handleUpdatePlan = async () => {
    try {
      if (
        !editingPlan?.Planename ||
        !editingPlan?.price ||
        !editingPlan?.commissionRate
      ) {
        return toast.error("Please fill all fields");
      }

      const { data } = await axios.put(
        `https://bioopay-full-backend.onrender.com/api/v1/plane/update-plane/${editingPlan._id}`,
        editingPlan
      );
      toast.success("Plan updated successfully");
      setEditingPlan(null);
      fetchPlans();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update plan");
      console.error("Error updating plan:", error);
    }
  };

  // Delete plan
  const handleDeletePlan = async (id) => {
    if (window.confirm("Are you sure you want to delete this plan?")) {
      try {
        await axios.delete(
          `https://bioopay-full-backend.onrender.com/api/v1/plane/delete-plane/${id}`
        );
        toast.success("Plan deleted successfully");
        fetchPlans();
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to delete plan");
        console.error("Error deleting plan:", error);
      }
    }
  };

  // Update user
  const handleUpdateUser = async () => {
    try {
      const { data } = await axios.put(
        `https://bioopay-full-backend.onrender.com/api/v1/users/update-users/${editingUser._id}`,
        editingUser
      );
      toast.success("User updated successfully");
      setEditingUser(null);
      fetchUsers();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update user");
      console.error("Error updating user:", error);
    }
  };

  // Delete user
  const handleDeleteUser = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await axios.delete(
          `https://bioopay-full-backend.onrender.com/api/v1/users/delete-users/${id}`
        );
        toast.success("User deleted successfully");
        fetchUsers();
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to delete user");
        console.error("Error deleting user:", error);
      }
    }
  };

  // Cancel editing
  const cancelEdit = () => {
    setEditingPlan(null);
    setEditingUser(null);
  };

  // Update account function
  const handleUpdateAccount = async () => {
    try {
      if (!editingAccount?.account || !editingAccount?.accountNumber) {
        return toast.error("Please fill all fields");
      }

      const { data } = await axios.put(
        `https://bioopay-full-backend.onrender.com/api/v1/depositeaccount/update-account/${editingAccount._id}`,
        editingAccount
      );
      toast.success("Account updated successfully");
      setEditingAccount(null);
      fetchDepositAccounts();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update account");
      console.error("Error updating account:", error);
    }
  };

  // Delete account function
  const handleDeleteAccount = async (id) => {
    if (window.confirm("Are you sure you want to delete this account?")) {
      try {
        await axios.delete(
          `https://bioopay-full-backend.onrender.com/api/v1/depositeaccount/delete-account/${id}`
        );
        toast.success("Account deleted successfully");
        fetchDepositAccounts();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to delete account"
        );
        console.error("Error deleting account:", error);
      }
    }
  };

  //depost get all part
  const fetchDeposits = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        "https://bioopay-full-backend.onrender.com/api/v1/deposite/all-deposite"
      );
      setDeposits(data?.deposits || []);
      setFilteredDeposits(data?.deposits || []);
    } catch (error) {
      toast.error("Failed to fetch deposits");
      console.error("Error fetching deposits:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleUpdateDepositStatus = async (depositId, newStatus) => {
    try {
      const { data } = await axios.put(
        `https://bioopay-full-backend.onrender.com/api/v1/deposite/update/${depositId}`,
        { status: newStatus }
      );
      toast.success("Deposit status updated successfully");
      fetchDeposits();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update deposit status"
      );
      console.error("Error updating deposit status:", error);
    }
  };

  const handleDeleteDeposit = async (depositId) => {
    if (window.confirm("Are you sure you want to delete this deposit?")) {
      try {
        await axios.delete(
          `https://bioopay-full-backend.onrender.com/api/v1/deposite/delete/${depositId}`
        );
        toast.success("Deposit deleted successfully");
        fetchDeposits();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to delete deposit"
        );
        console.error("Error deleting deposit:", error);
      }
    }
  };
  useEffect(() => {
    fetchDepositAccounts();
    fetchDeposits(); // Add this line
  }, []);
  const handleDepositSearch = (e) => {
    const term = e.target.value;
    setDepositSearchTerm(term);

    if (term === "") {
      setFilteredDeposits(deposits);
      return;
    }

    const filtered = deposits.filter(
      (deposit) =>
        deposit?.transactionId?.toLowerCase().includes(term.toLowerCase()) ||
        deposit?.user?.username?.toLowerCase().includes(term.toLowerCase()) ||
        deposit?.status?.toLowerCase().includes(term.toLowerCase())
    );

    setFilteredDeposits(filtered);
    setDepositsCurrentPage(1);
  };
  // Filter users based on search term
  const filteredUsers = users.filter(
    (user) =>
      user?.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  // Pagination logic for deposits
  const indexOfLastDeposit = depositsCurrentPage * depositsPerPage;
  const indexOfFirstDeposit = indexOfLastDeposit - depositsPerPage;
  const currentDeposits = filteredDeposits.slice(
    indexOfFirstDeposit,
    indexOfLastDeposit
  );
  const totalDepositPages = Math.ceil(
    filteredDeposits.length / depositsPerPage
  );

  const paginateDeposits = (pageNumber) => setDepositsCurrentPage(pageNumber);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    toast.success("Logged out successfully!");
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  // Dark theme styles
  const darkStyles = {
    container: {
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      backgroundColor: darkMode ? "#1a202c" : "#F3F4F6",
      minHeight: "100vh",
      padding: "20px",
      color: darkMode ? "#e2e8f0" : "#374151",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
    },
    headerTitle: {
      fontSize: "28px",
      fontWeight: "600",
      color: darkMode ? "#ffffff" : "#111827",
    },
    headerActions: {
      display: "flex",
      gap: "12px",
    },
    button: {
      padding: "8px 16px",
      borderRadius: "6px",
      border: darkMode ? "1px solid #4a5568" : "1px solid #D1D5DB",
      backgroundColor: darkMode ? "#2d3748" : "white",
      color: darkMode ? "#e2e8f0" : "#374151",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      transition: "all 0.2s",
    },
    primaryButton: {
      backgroundColor: "#4299e1",
      color: "white",
      borderColor: "#4299e1",
    },
    statsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "16px",
      marginBottom: "24px",
    },
    statCard: {
      backgroundColor: darkMode ? "#2d3748" : "white",
      borderRadius: "8px",
      padding: "16px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    statTitle: {
      fontSize: "14px",
      color: darkMode ? "#a0aec0" : "#6B7280",
      margin: "0 0 8px 0",
    },
    statValue: {
      fontSize: "24px",
      fontWeight: "600",
      margin: "0 0 4px 0",
      color: darkMode ? "#ffffff" : "#111827",
    },
    statChange: {
      fontSize: "12px",
      margin: "0",
    },
    content: {
      display: "grid",
      gridTemplateColumns: "2fr 1fr",
      gap: "24px",
    },
    card: {
      backgroundColor: darkMode ? "#2d3748" : "white",
      borderRadius: "8px",
      padding: "20px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      marginBottom: "24px",
    },
    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    },
    cardTitle: {
      fontSize: "18px",
      fontWeight: "600",
      margin: "0",
      color: darkMode ? "#ffffff" : "#111827",
    },
    searchInput: {
      padding: "8px 12px",
      borderRadius: "6px",
      border: darkMode ? "1px solid #4a5568" : "1px solid #D1D5DB",
      backgroundColor: darkMode ? "#2d3748" : "white",
      color: darkMode ? "#e2e8f0" : "#374151",
      fontSize: "14px",
      width: "200px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    tableHeaderRow: {
      borderBottom: darkMode ? "1px solid #4a5568" : "1px solid #E5E7EB",
    },
    tableHeader: {
      padding: "12px",
      textAlign: "left",
      fontSize: "14px",
      fontWeight: "600",
      color: darkMode ? "#a0aec0" : "#6B7280",
    },
    tableRow: {
      borderBottom: darkMode ? "1px solid #4a5568" : "1px solid #E5E7EB",
      "&:hover": {
        backgroundColor: darkMode ? "#4a5568" : "#F9FAFB",
      },
    },
    tableCell: {
      padding: "12px",
      fontSize: "14px",
    },
    smallButton: {
      padding: "4px 8px",
      borderRadius: "4px",
      border: darkMode ? "1px solid #4a5568" : "1px solid #D1D5DB",
      backgroundColor: darkMode ? "#2d3748" : "white",
      color: darkMode ? "#e2e8f0" : "#374151",
      cursor: "pointer",
      fontSize: "12px",
      marginRight: "4px",
    },
    dangerButton: {
      backgroundColor: darkMode ? "#742a2a" : "#FEE2E2",
      color: darkMode ? "#feb2b2" : "#B91C1C",
      borderColor: darkMode ? "#742a2a" : "#FECACA",
    },
    successButton: {
      backgroundColor: darkMode ? "#22543d" : "#D1FAE5",
      color: darkMode ? "#9ae6b4" : "#065F46",
      borderColor: darkMode ? "#22543d" : "#A7F3D0",
    },
    sidebar: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    quickActions: {
      listStyle: "none",
      padding: "0",
      margin: "0",
    },
    quickActionItem: {
      marginBottom: "8px",
    },
    sidebarButton: {
      width: "100%",
      padding: "8px 12px",
      textAlign: "left",
      backgroundColor: darkMode ? "#2d3748" : "white",
      border: darkMode ? "1px solid #4a5568" : "1px solid #E5E7EB",
      color: darkMode ? "#e2e8f0" : "#374151",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.2s",
      "&:hover": {
        backgroundColor: darkMode ? "#4a5568" : "#F3F4F6",
      },
    },
    activityList: {
      listStyle: "none",
      padding: "0",
      margin: "0",
    },
    activityItem: {
      padding: "12px 0",
      borderBottom: darkMode ? "1px solid #4a5568" : "1px solid #E5E7EB",
    },
    activityText: {
      margin: "0 0 4px 0",
      fontSize: "14px",
    },
    activityTime: {
      margin: "0",
      fontSize: "12px",
      color: darkMode ? "#a0aec0" : "#6B7280",
    },
    formGroup: {
      marginBottom: "16px",
    },
    formLabel: {
      display: "block",
      marginBottom: "8px",
      fontSize: "14px",
      color: darkMode ? "#a0aec0" : "#6B7280",
    },
    formInput: {
      width: "100%",
      padding: "8px 12px",
      borderRadius: "6px",
      border: darkMode ? "1px solid #4a5568" : "1px solid #D1D5DB",
      backgroundColor: darkMode ? "#2d3748" : "white",
      color: darkMode ? "#e2e8f0" : "#374151",
      fontSize: "14px",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: "600",
      margin: "0 0 16px 0",
      color: darkMode ? "#ffffff" : "#111827",
    },
  };

  return (
    <div style={darkStyles.container}>
      {/* Header */}
      <div style={darkStyles.header}>
        <h1 style={darkStyles.headerTitle}>
          Owner: {auth?.user?.userName || "Not logged in"}
        </h1>
        <div style={darkStyles.headerActions}>
          <button
            style={{ ...darkStyles.button, ...darkStyles.primaryButton }}
            onClick={toggleTheme}
          >
            {darkMode ? "Light Mode" : "Dark Mode"}
          </button>
          <button
            style={darkStyles.button}
            onClick={() => {
              fetchUsers();
              fetchPlans();
              fetchDepositAccounts();
              fetchDeposits();
              fetchCashouts(); // Add this line
            }}
          >
            Refresh
          </button>
          <button
            onClick={handleLogout}
            style={{ ...darkStyles.button, ...darkStyles.primaryButton }}
          >
            Logout
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div style={darkStyles.statsContainer}>
        {stats.map((stat, index) => (
          <div key={index} style={darkStyles.statCard}>
            <h3 style={darkStyles.statTitle}>{stat.title}</h3>
            <p style={darkStyles.statValue}>{stat.value}</p>
            <p
              style={{
                ...darkStyles.statChange,
                color: stat.isPositive ? "#48BB78" : "#F56565",
              }}
            >
              {stat.change}
            </p>
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div style={darkStyles.content}>
        {/* Left Column */}

        <div>
          {/* Latest Users */}
          <div style={darkStyles.card}>
            <h2 style={darkStyles.cardTitle}>Latest Users</h2>
            <table style={darkStyles.table}>
              <thead>
                <tr style={darkStyles.tableHeaderRow}>
                  <th style={darkStyles.tableHeader}>Username</th>
                  <th style={darkStyles.tableHeader}>Email</th>
                  <th style={darkStyles.tableHeader}>TotalEarnings</th>
                  <th style={darkStyles.tableHeader}>AvaliableEarnings</th>
                  <th style={darkStyles.tableHeader}>TotalTeams</th>
                  <th style={darkStyles.tableHeader}>Status</th>
                  <th style={darkStyles.tableHeader}>Joined</th>
                  <th style={darkStyles.tableHeader}>Last Login</th>
                </tr>
              </thead>
              <tbody>
                {latestUsers.map((user) => (
                  <tr key={user?._id} style={darkStyles.tableRow}>
                    <td style={darkStyles.tableCell}>{user?.userName}</td>
                    <td style={darkStyles.tableCell}>{user?.email}</td>
                    <td style={darkStyles.tableCell}>{user?.TotalEarnings}</td>
                    <td style={darkStyles.tableCell}>{user?.earnings}</td>
                    <td style={darkStyles.tableCell}>{user?.totalReferred}</td>
                    <td
                      style={{
                        ...darkStyles.tableCell,
                        color:
                          user?.accountStatus === "active"
                            ? "#48BB78"
                            : user?.accountStatus === "pending"
                            ? "#ECC94B"
                            : "#F56565",
                      }}
                    >
                      {user?.accountStatus}
                    </td>
                    <td style={darkStyles.tableCell}>
                      {user?.createdAt
                        ? new Date(user.createdAt).toLocaleDateString()
                        : "N/A"}
                    </td>
                    <td style={darkStyles.tableCell}>
                      {user?.lastLoginAt ? format(user.lastLoginAt) : "Never"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* All Users */}
          <div style={darkStyles.card}>
            <div style={darkStyles.cardHeader}>
              <h2 style={darkStyles.cardTitle}>All Users ({users.length})</h2>
              <input
                type="text"
                placeholder="Search users..."
                style={darkStyles.searchInput}
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            {editingUser ? (
              <div style={{ padding: "20px" }}>
                <h3 style={{ marginBottom: "20px" }}>Edit User</h3>
                <div style={darkStyles.formGroup}>
                  <label style={darkStyles.formLabel}>Username</label>
                  <input
                    type="text"
                    name="userName"
                    style={darkStyles.formInput}
                    value={editingUser?.userName || ""}
                    onChange={handleUserInputChange}
                  />
                </div>
                <div style={darkStyles.formGroup}>
                  <label style={darkStyles.formLabel}>Email</label>
                  <input
                    type="email"
                    name="email"
                    style={darkStyles.formInput}
                    value={editingUser?.email || ""}
                    onChange={handleUserInputChange}
                  />
                </div>
                <div style={darkStyles.formGroup}>
                  <label style={darkStyles.formLabel}>TotalEarning</label>
                  <input
                    type="text"
                    name="TotalEarnings"
                    style={darkStyles.formInput}
                    value={editingUser?.TotalEarnings || ""}
                    onChange={handleUserInputChange}
                  />
                </div>

                <div style={darkStyles.formGroup}>
                  <label style={darkStyles.formLabel}>AvailableEarning</label>
                  <input
                    type="text"
                    name="earnings"
                    style={darkStyles.formInput}
                    value={editingUser?.earnings || ""}
                    onChange={handleUserInputChange}
                  />
                </div>

                <div style={darkStyles.formGroup}>
                  <label style={darkStyles.formLabel}>Account Status</label>
                  <select
                    name="accountStatus"
                    style={darkStyles.formInput}
                    value={editingUser?.accountStatus || "active"}
                    onChange={handleUserInputChange}
                  >
                    <option value="active">Active</option>
                    <option value="pending">Pending</option>
                    <option value="suspended">Suspended</option>
                    <option value="banned">Banned</option>
                  </select>
                </div>
                <div style={darkStyles.formGroup}>
                  <label style={darkStyles.formLabel}>Role</label>
                  <select
                    name="role"
                    style={darkStyles.formInput}
                    value={editingUser?.role || "user"}
                    onChange={handleUserInputChange}
                  >
                    <option value="user">User</option>
                    <option value="editor">Editor</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <div
                  style={{ display: "flex", gap: "10px", marginTop: "20px" }}
                >
                  <button
                    style={{
                      ...darkStyles.button,
                      ...darkStyles.primaryButton,
                      flex: 1,
                    }}
                    onClick={handleUpdateUser}
                  >
                    Update User
                  </button>
                  <button
                    style={{
                      ...darkStyles.button,
                      flex: 1,
                    }}
                    onClick={cancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <>
                <table style={darkStyles.table}>
                  <thead>
                    <tr style={darkStyles.tableHeaderRow}>
                      <th style={darkStyles.tableHeader}>Username</th>
                      <th style={darkStyles.tableHeader}>Email</th>
                      <th style={darkStyles.tableHeader}>TotalEarnings</th>
                      <th style={darkStyles.tableHeader}>AvaliableEarnings</th>
                      <th style={darkStyles.tableHeader}>totalReferred</th>
                      <th style={darkStyles.tableHeader}>Role</th>
                      <th style={darkStyles.tableHeader}>Status</th>
                      <th style={darkStyles.tableHeader}>Joined</th>
                      <th style={darkStyles.tableHeader}>Last Login</th>
                      <th style={darkStyles.tableHeader}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.map((user) => (
                      <tr key={user?._id} style={darkStyles.tableRow}>
                        <td style={darkStyles.tableCell}>{user?.userName}</td>
                        <td style={darkStyles.tableCell}>{user?.email}</td>
                        <td style={darkStyles.tableCell}>
                          {user?.TotalEarnings}
                        </td>
                        <td style={darkStyles.tableCell}>{user?.earnings}</td>
                        <td style={darkStyles.tableCell}>
                          {user?.totalReferred}
                        </td>
                        <td style={darkStyles.tableCell}>{user?.role}</td>
                        <td
                          style={{
                            ...darkStyles.tableCell,
                            color:
                              user?.accountStatus === "active"
                                ? "#48BB78"
                                : user?.accountStatus === "pending"
                                ? "#ECC94B"
                                : "#F56565",
                          }}
                        >
                          {user?.accountStatus}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {user?.createdAt
                            ? new Date(user.createdAt).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {user?.lastLoginAt
                            ? format(user.lastLoginAt)
                            : "Never"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          <button
                            style={darkStyles.smallButton}
                            onClick={() => setEditingUser({ ...user })}
                          >
                            Edit
                          </button>
                          <button
                            style={{
                              ...darkStyles.smallButton,
                              ...darkStyles.dangerButton,
                            }}
                            onClick={() => handleDeleteUser(user?._id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (number) => (
                        <button
                          key={number}
                          style={{
                            ...darkStyles.button,
                            margin: "0 5px",
                            backgroundColor:
                              currentPage === number
                                ? darkMode
                                  ? "#4299e1"
                                  : "#3182ce"
                                : darkMode
                                ? "#2d3748"
                                : "white",
                            color:
                              currentPage === number
                                ? "white"
                                : darkMode
                                ? "#e2e8f0"
                                : "#374151",
                          }}
                          onClick={() => paginate(number)}
                        >
                          {number}
                        </button>
                      )
                    )}
                  </div>
                )}
              </>
            )}
          </div>
          {/* Deposits Management */}
          {/* Deposits Management */}
          <div style={darkStyles.card}>
            <div style={darkStyles.cardHeader}>
              <h2 style={darkStyles.cardTitle}>
                All Deposits ({filteredDeposits.length})
              </h2>
              <input
                type="text"
                placeholder="Search deposits..."
                style={darkStyles.searchInput}
                value={depositSearchTerm}
                onChange={handleDepositSearch}
              />
            </div>

            {loading ? (
              <p>Loading deposits...</p>
            ) : (
              <>
                {/* Image Modal */}
                {showModal && selectedImage && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.8)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1000,
                    }}
                    onClick={() => setShowModal(false)}
                  >
                    <img
                      src={selectedImage}
                      alt="Deposit proof"
                      style={{
                        maxWidth: "90%",
                        maxHeight: "90%",
                        border: "2px solid white",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                )}

                <table style={darkStyles.table}>
                  <thead>
                    <tr style={darkStyles.tableHeaderRow}>
                      <th style={darkStyles.tableHeader}>User</th>
                      <th style={darkStyles.tableHeader}>Plan</th>
                      <th style={darkStyles.tableHeader}>Amount</th>
                      <th style={darkStyles.tableHeader}>Transaction ID</th>
                      <th style={darkStyles.tableHeader}>Image</th>
                      <th style={darkStyles.tableHeader}>Status</th>
                      <th style={darkStyles.tableHeader}>Date</th>
                      <th style={darkStyles.tableHeader}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentDeposits.map((deposit) => (
                      <tr key={deposit?._id} style={darkStyles.tableRow}>
                        <td style={darkStyles.tableCell}>
                          {deposit?.user?.email || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {deposit?.plan?.Planename || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          ${deposit?.amount || "0"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {deposit?.transactionId || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {deposit?.image ? (
                            <img
                              src={deposit.image}
                              alt="Deposit proof"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSelectedImage(deposit.image);
                                setShowModal(true);
                              }}
                            />
                          ) : (
                            "No image"
                          )}
                        </td>
                        <td
                          style={{
                            ...darkStyles.tableCell,
                            color:
                              deposit?.status === "active"
                                ? "#48BB78"
                                : deposit?.status === "pending"
                                ? "#ECC94B"
                                : "#F56565",
                          }}
                        >
                          {deposit?.status}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {deposit?.createdAt
                            ? new Date(deposit.createdAt).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          <select
                            style={darkStyles.formInput}
                            value={deposit?.status}
                            onChange={(e) =>
                              handleUpdateDepositStatus(
                                deposit._id,
                                e.target.value
                              )
                            }
                          >
                            <option value="pending">Pending</option>
                            <option value="active">Active</option>
                            <option value="failed">Failed</option>
                          </select>
                          <button
                            style={{
                              ...darkStyles.smallButton,
                              ...darkStyles.dangerButton,
                              marginTop: "5px",
                            }}
                            onClick={() => handleDeleteDeposit(deposit._id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Deposits Pagination */}
                {totalDepositPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    {Array.from(
                      { length: totalDepositPages },
                      (_, i) => i + 1
                    ).map((number) => (
                      <button
                        key={number}
                        style={{
                          ...darkStyles.button,
                          margin: "0 5px",
                          backgroundColor:
                            depositsCurrentPage === number
                              ? darkMode
                                ? "#4299e1"
                                : "#3182ce"
                              : darkMode
                              ? "#2d3748"
                              : "white",
                          color:
                            depositsCurrentPage === number
                              ? "white"
                              : darkMode
                              ? "#e2e8f0"
                              : "#374151",
                        }}
                        onClick={() => paginateDeposits(number)}
                      >
                        {number}
                      </button>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* Right Column */}
        <div style={darkStyles.sidebar}>
          {/* Pending Withdrawals */}
          <div style={darkStyles.card}>
            <h2 style={darkStyles.cardTitle}>Pending Withdrawals</h2>
            <table style={darkStyles.table}>
              <thead>
                <tr style={darkStyles.tableHeaderRow}>
                  <th style={darkStyles.tableHeader}>ID</th>
                  <th style={darkStyles.tableHeader}>User ID</th>
                  <th style={darkStyles.tableHeader}>Amount</th>
                  <th style={darkStyles.tableHeader}>Method</th>
                  <th style={darkStyles.tableHeader}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {pendingWithdrawals.map((withdrawal) => (
                  <tr key={withdrawal?.id} style={darkStyles.tableRow}>
                    <td style={darkStyles.tableCell}>{withdrawal?.id}</td>
                    <td style={darkStyles.tableCell}>{withdrawal?.userId}</td>
                    <td style={darkStyles.tableCell}>{withdrawal?.amount}</td>
                    <td style={darkStyles.tableCell}>{withdrawal?.method}</td>
                    <td style={darkStyles.tableCell}>
                      <button
                        style={{
                          ...darkStyles.smallButton,
                          ...darkStyles.successButton,
                        }}
                      >
                        Approve
                      </button>
                      <button
                        style={{
                          ...darkStyles.smallButton,
                          ...darkStyles.dangerButton,
                        }}
                      >
                        Reject
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Investment Plans */}
          <div style={darkStyles.card}>
            <h2 style={darkStyles.cardTitle}>Investment Plans</h2>
            {loading ? (
              <p>Loading plans...</p>
            ) : (
              <table style={darkStyles.table}>
                <thead>
                  <tr style={darkStyles.tableHeaderRow}>
                    <th style={darkStyles.tableHeader}>Plan</th>
                    <th style={darkStyles.tableHeader}>Price</th>
                    <th style={darkStyles.tableHeader}>Commission</th>
                    <th style={darkStyles.tableHeader}>Ads Earning</th>

                    <th style={darkStyles.tableHeader}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {investmentPlans.map((plan) => (
                    <tr key={plan?._id} style={darkStyles.tableRow}>
                      <td style={darkStyles.tableCell}>{plan?.Planename}</td>
                      <td style={darkStyles.tableCell}>${plan?.price}</td>
                      <td style={darkStyles.tableCell}>
                        {plan?.commissionRate}$
                      </td>
                      <td style={darkStyles.tableCell}>${plan?.AdsEarnings}</td>

                      <td style={darkStyles.tableCell}>
                        <button
                          style={darkStyles.smallButton}
                          onClick={() => setEditingPlan({ ...plan })}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            ...darkStyles.smallButton,
                            ...darkStyles.dangerButton,
                          }}
                          onClick={() => handleDeletePlan(plan?._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {/* User Ad Details Card */}
          {/* User Ad Details Card */}
          <div style={darkStyles.card}>
            <h2 style={darkStyles.cardTitle}>User Ad Statistics</h2>

            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Search by Email</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="email"
                  style={darkStyles.formInput}
                  value={adSearchEmail}
                  onChange={(e) => setAdSearchEmail(e.target.value)}
                  placeholder="Enter user email"
                />
                <button
                  style={{
                    ...darkStyles.button,
                    ...darkStyles.primaryButton,
                    whiteSpace: "nowrap",
                  }}
                  onClick={fetchUserAdDetails}
                >
                  Search Ads
                </button>
              </div>
            </div>

            {userAdDetails && (
              <div style={{ marginTop: "20px" }}>
                <h3 style={{ marginBottom: "10px" }}>User Details</h3>

                <p>
                  <strong>Email:</strong>{" "}
                  {userAdDetails.user?.email || adSearchEmail}
                </p>

                <h3 style={{ margin: "20px 0 10px 0" }}>Ad Statistics</h3>
                <table style={darkStyles.table}>
                  <thead>
                    <tr style={darkStyles.tableHeaderRow}>
                      <th style={darkStyles.tableHeader}>Total Ads Watched</th>
                      <th style={darkStyles.tableHeader}>
                        Total Earnings From Ads
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={darkStyles.tableRow}>
                      <td style={darkStyles.tableCell}>
                        {userAdDetails.totalAdsWatched || 0}
                      </td>
                      <td style={darkStyles.tableCell}>
                        ${(userAdDetails.totalEarningsFromAds || 0).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h3 style={{ margin: "20px 0 10px 0" }}>Recent Ad Watches</h3>
                {userAdDetails.userAds && userAdDetails.userAds.length > 0 ? (
                  <table style={darkStyles.table}>
                    <thead>
                      <tr style={darkStyles.tableHeaderRow}>
                        <th style={darkStyles.tableHeader}>Date</th>
                        <th style={darkStyles.tableHeader}>Plan</th>
                        <th style={darkStyles.tableHeader}>Duration</th>
                        <th style={darkStyles.tableHeader}>Earnings</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userAdDetails.userAds.map((ad) => (
                        <tr
                          key={ad._id || Math.random()}
                          style={darkStyles.tableRow}
                        >
                          <td style={darkStyles.tableCell}>
                            {ad.watchedAt
                              ? new Date(ad.watchedAt).toLocaleString()
                              : "N/A"}
                          </td>
                          <td style={darkStyles.tableCell}>
                            {ad.plan?.Planename || "N/A"}
                          </td>
                          <td style={darkStyles.tableCell}>
                            {ad.watchedDuration || 0} seconds
                          </td>
                          <td style={darkStyles.tableCell}>
                            ${(ad.earnedAmount || 0).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No ad watch records found</p>
                )}
              </div>
            )}
          </div>
          {/* Add/Edit Plan Form */}
          <div style={darkStyles.card}>
            <h2 style={darkStyles.cardTitle}>
              {editingPlan ? "Edit Plan" : "Add New Plan"}
            </h2>

            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Plan Name</label>
              <input
                type="text"
                name="Planename"
                style={darkStyles.formInput}
                value={
                  editingPlan ? editingPlan?.Planename : newPlan?.Planename
                }
                onChange={handlePlanInputChange}
              />
            </div>

            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Price ($)</label>
              <input
                type="number"
                name="price"
                style={darkStyles.formInput}
                value={editingPlan ? editingPlan?.price : newPlan?.price}
                onChange={handlePlanInputChange}
              />
            </div>

            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Commission Rate (%)</label>
              <input
                type="number"
                name="commissionRate"
                style={darkStyles.formInput}
                value={
                  editingPlan
                    ? editingPlan?.commissionRate
                    : newPlan?.commissionRate
                }
                onChange={handlePlanInputChange}
              />
            </div>
            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Commission Rate (%)</label>
              <input
                type="number"
                name="AdsEarnings"
                style={darkStyles.formInput}
                value={
                  editingPlan ? editingPlan?.AdsEarnings : newPlan?.AdsEarnings
                }
                onChange={handlePlanInputChange}
              />
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              {editingPlan ? (
                <>
                  <button
                    style={{
                      ...darkStyles.button,
                      ...darkStyles.primaryButton,
                      flex: 1,
                    }}
                    onClick={handleUpdatePlan}
                  >
                    Update Plan
                  </button>
                  <button
                    style={{
                      ...darkStyles.button,
                      flex: 1,
                    }}
                    onClick={cancelEdit}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  style={{
                    ...darkStyles.button,
                    ...darkStyles.primaryButton,
                    width: "100%",
                  }}
                  onClick={handleAddPlan}
                >
                  Add Plan
                </button>
              )}
            </div>
          </div>

          {/* Account Card */}
          <div style={darkStyles.card}>
            <h2 style={darkStyles.cardTitle}>Deposit Accounts</h2>

            {/* Create/Edit account form */}
            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Account Type</label>
              <input
                type="text"
                style={darkStyles.formInput}
                value={
                  editingAccount
                    ? editingAccount?.account
                    : newDepositAccount?.account
                }
                onChange={(e) =>
                  editingAccount
                    ? setEditingAccount({
                        ...editingAccount,
                        account: e.target.value,
                      })
                    : setNewDepositAccount({
                        ...newDepositAccount,
                        account: e.target.value,
                      })
                }
                placeholder="e.g., easypaisa, jazzcash"
              />
            </div>

            <div style={darkStyles.formGroup}>
              <label style={darkStyles.formLabel}>Account Number</label>
              <input
                type="text"
                style={darkStyles.formInput}
                value={
                  editingAccount
                    ? editingAccount?.accountNumber
                    : newDepositAccount?.accountNumber
                }
                onChange={(e) =>
                  editingAccount
                    ? setEditingAccount({
                        ...editingAccount,
                        accountNumber: e.target.value,
                      })
                    : setNewDepositAccount({
                        ...newDepositAccount,
                        accountNumber: e.target.value,
                      })
                }
                placeholder="e.g., 03001234567"
              />
            </div>

            {editingAccount ? (
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  style={{
                    ...darkStyles.button,
                    ...darkStyles.primaryButton,
                    flex: 1,
                  }}
                  onClick={handleUpdateAccount}
                >
                  Update Account
                </button>
                <button
                  style={{
                    ...darkStyles.button,
                    flex: 1,
                  }}
                  onClick={() => setEditingAccount(null)}
                >
                  Cancel
                </button>
              </div>
            ) : (
              <button
                style={{
                  ...darkStyles.button,
                  ...darkStyles.primaryButton,
                  width: "100%",
                }}
                onClick={createDepositAccount}
              >
                Create Account
              </button>
            )}

            {/* Accounts list */}
            {/* Accounts list */}
            <table style={{ ...darkStyles.table, marginTop: "20px" }}>
              <thead>
                <tr style={darkStyles.tableHeaderRow}>
                  <th style={darkStyles.tableHeader}>Account Type</th>
                  <th style={darkStyles.tableHeader}>Account Number</th>
                  <th style={darkStyles.tableHeader}>Created</th>
                  <th style={darkStyles.tableHeader}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(depositAccounts) &&
                  depositAccounts.map((account) => (
                    <tr key={account?._id} style={darkStyles.tableRow}>
                      <td style={darkStyles.tableCell}>{account?.account}</td>
                      <td style={darkStyles.tableCell}>
                        {account?.accountNumber}
                      </td>
                      <td style={darkStyles.tableCell}>
                        {account?.createdAt
                          ? new Date(account.createdAt).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td style={darkStyles.tableCell}>
                        <button
                          style={darkStyles.smallButton}
                          onClick={() => setEditingAccount({ ...account })}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            ...darkStyles.smallButton,
                            ...darkStyles.dangerButton,
                          }}
                          onClick={() => handleDeleteAccount(account?._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* //cashout// */}
        {/* Cashout Requests */}
        <div style={darkStyles.card}>
          <div style={darkStyles.cardHeader}>
            <h2 style={darkStyles.cardTitle}>
              Cashout Requests ({filteredCashouts.length})
            </h2>
            <input
              type="text"
              placeholder="Search cashouts..."
              style={darkStyles.searchInput}
              value={cashoutSearchTerm}
              onChange={handleCashoutSearch}
            />
          </div>

          {loading ? (
            <p>Loading cashouts...</p>
          ) : filteredCashouts.length === 0 ? (
            <p>No cashout requests found</p>
          ) : (
            <>
              <table style={darkStyles.table}>
                <thead>
                  <tr style={darkStyles.tableHeaderRow}>
                    <th style={darkStyles.tableHeader}>User</th>
                    <th style={darkStyles.tableHeader}>Amount</th>
                    <th style={darkStyles.tableHeader}>Account Type</th>
                    <th style={darkStyles.tableHeader}>Account Number</th>
                    <th style={darkStyles.tableHeader}>Remark </th>

                    <th style={darkStyles.tableHeader}>Status</th>
                    <th style={darkStyles.tableHeader}>Date</th>
                    <th style={darkStyles.tableHeader}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCashouts
                    .slice(
                      (cashoutsCurrentPage - 1) * cashoutsPerPage,
                      cashoutsCurrentPage * cashoutsPerPage
                    )
                    .map((cashout) => (
                      <tr key={cashout?._id} style={darkStyles.tableRow}>
                        <td style={darkStyles.tableCell}>
                          {cashout?.user?.email || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          ${cashout?.amount || "0"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {cashout?.accountType || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {cashout?.accountNumber || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {cashout?.remarks || "N/A"}
                        </td>
                        <td
                          style={{
                            ...darkStyles.tableCell,
                            color:
                              cashout?.status === "approved"
                                ? "#48BB78"
                                : cashout?.status === "pending"
                                ? "#ECC94B"
                                : "#F56565",
                          }}
                        >
                          {cashout?.status}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {cashout?.createdAt
                            ? new Date(cashout.createdAt).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {cashout?.status === "pending" && (
                            <>
                              <div style={{ marginBottom: "5px" }}>
                                <select
                                  style={darkStyles.formInput}
                                  value={cashout?.status || "pending"}
                                  onChange={(e) => {
                                    handleUpdateCashoutStatus(
                                      cashout._id,
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="pending">Pending</option>
                                  <option value="approved">Approved</option>
                                  <option value="rejected">Rejected</option>
                                </select>
                              </div>
                              <input
                                type="text"
                                placeholder="Remarks (optional)"
                                style={{
                                  ...darkStyles.formInput,
                                  marginBottom: "5px",
                                  width: "100%",
                                }}
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                              />
                            </>
                          )}
                          {cashout?.status !== "pending" && (
                            <span>Action completed</span>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {/* Pagination */}
              {Math.ceil(filteredCashouts.length / cashoutsPerPage) > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  {Array.from(
                    {
                      length: Math.ceil(
                        filteredCashouts.length / cashoutsPerPage
                      ),
                    },
                    (_, i) => i + 1
                  ).map((number) => (
                    <button
                      key={number}
                      style={{
                        ...darkStyles.button,
                        margin: "0 5px",
                        backgroundColor:
                          cashoutsCurrentPage === number
                            ? darkMode
                              ? "#4299e1"
                              : "#3182ce"
                            : darkMode
                            ? "#2d3748"
                            : "white",
                        color:
                          cashoutsCurrentPage === number
                            ? "white"
                            : darkMode
                            ? "#e2e8f0"
                            : "#374151",
                      }}
                      onClick={() => setCashoutsCurrentPage(number)}
                    >
                      {number}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
        {/* Add this card in your right column section */}
        <div style={darkStyles.card}>
          <h2 style={darkStyles.cardTitle}>Search Referral Network</h2>

          <div style={darkStyles.formGroup}>
            <label style={darkStyles.formLabel}>Search by Email</label>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="email"
                style={darkStyles.formInput}
                value={searchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
                placeholder="Enter user email"
              />
              <button
                style={{
                  ...darkStyles.button,
                  ...darkStyles.primaryButton,
                  whiteSpace: "nowrap",
                }}
                onClick={handleSearchByEmail}
              >
                Search
              </button>
            </div>
          </div>

          {searchedUser && (
            <div style={{ marginTop: "20px" }}>
              <h3 style={{ marginBottom: "10px" }}>User Details</h3>
              <p>
                <strong>Name:</strong> {searchedUser.userName}
              </p>
              <p>
                <strong>Email:</strong> {searchedUser.email}
              </p>
              <p>
                <strong>Referral Code:</strong> {searchedUser.referralCode}
              </p>

              <h3 style={{ margin: "20px 0 10px 0" }}>Referral Network</h3>
              {referralTree.length > 0 ? (
                <ReferralTreeDisplay tree={referralTree} />
              ) : (
                <p>No referrals found for this user.</p>
              )}
            </div>
          )}
        </div>
        {/* Advance Requests Card */}
        {/* Advance Requests Card */}
        <div style={darkStyles.card}>
          <div style={darkStyles.cardHeader}>
            <h2 style={darkStyles.cardTitle}>
              Advance Requests ({filteredAdvances.length})
            </h2>
            <input
              type="text"
              placeholder="Search advances..."
              style={darkStyles.searchInput}
              value={advanceSearchTerm}
              onChange={handleAdvanceSearch}
            />
          </div>

          {loading ? (
            <p>Loading advance requests...</p>
          ) : filteredAdvances.length === 0 ? (
            <p>No advance requests found</p>
          ) : (
            <>
              <table style={darkStyles.table}>
                <thead>
                  <tr style={darkStyles.tableHeaderRow}>
                    <th style={darkStyles.tableHeader}>User</th>
                    <th style={darkStyles.tableHeader}>Team Size</th>
                    <th style={darkStyles.tableHeader}>Team Category</th>
                    <th style={darkStyles.tableHeader}>Advance Received</th>
                    <th style={darkStyles.tableHeader}>User Comment</th>
                    <th style={darkStyles.tableHeader}>Status</th>
                    <th style={darkStyles.tableHeader}>Remarks</th>
                    <th style={darkStyles.tableHeader}>Date</th>
                    <th style={darkStyles.tableHeader}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAdvances
                    .slice(
                      (advancesCurrentPage - 1) * advancesPerPage,
                      advancesCurrentPage * advancesPerPage
                    )
                    .map((advance) => (
                      <tr key={advance?._id} style={darkStyles.tableRow}>
                        <td style={darkStyles.tableCell}>
                          {advance?.user?.email || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {advance?.teamSizeAtApplication || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {advance?.teamCategory || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          ${advance?.calculatedAdvanceAmount || "0"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {advance?.userComment || "N/A"}
                        </td>
                        <td
                          style={{
                            ...darkStyles.tableCell,
                            color:
                              advance?.status === "approved"
                                ? "#48BB78"
                                : advance?.status === "pending"
                                ? "#ECC94B"
                                : "#F56565",
                          }}
                        >
                          {advance?.status}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {advance?.remarks || "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {advance?.createdAt
                            ? new Date(advance.createdAt).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td style={darkStyles.tableCell}>
                          {advance?.status === "pending" && (
                            <>
                              <div style={{ marginBottom: "5px" }}>
                                <select
                                  style={darkStyles.formInput}
                                  value={advance?.status || "pending"}
                                  onChange={(e) => {
                                    handleUpdateAdvanceStatus(
                                      advance._id,
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="pending">Pending</option>
                                  <option value="approved">Approved</option>
                                  <option value="rejected">Rejected</option>
                                </select>
                              </div>
                              <input
                                type="text"
                                placeholder="Remarks (optional)"
                                style={{
                                  ...darkStyles.formInput,
                                  marginBottom: "5px",
                                  width: "100%",
                                }}
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                              />
                            </>
                          )}
                          {advance?.status !== "pending" && (
                            <span>Action completed</span>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {/* Pagination */}
              {Math.ceil(filteredAdvances.length / advancesPerPage) > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  {Array.from(
                    {
                      length: Math.ceil(
                        filteredAdvances.length / advancesPerPage
                      ),
                    },
                    (_, i) => i + 1
                  ).map((number) => (
                    <button
                      key={number}
                      style={{
                        ...darkStyles.button,
                        margin: "0 5px",
                        backgroundColor:
                          advancesCurrentPage === number
                            ? darkMode
                              ? "#4299e1"
                              : "#3182ce"
                            : darkMode
                            ? "#2d3748"
                            : "white",
                        color:
                          advancesCurrentPage === number
                            ? "white"
                            : darkMode
                            ? "#e2e8f0"
                            : "#374151",
                      }}
                      onClick={() => setAdvancesCurrentPage(number)}
                    >
                      {number}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={darkMode ? "dark" : "light"}
      />
    </div>
  );
};

export const ReferralTreeDisplay = ({ tree, level = 0 }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        position: "relative",
        paddingLeft: level > 0 ? "30px" : "0",
      }}
    >
      {tree.map((user, index) => (
        <div
          key={index}
          style={{
            position: "relative",
          }}
        >
          {/* Connection line */}
          {level > 0 && (
            <div
              style={{
                position: "absolute",
                left: "-20px",
                top: "24px",
                bottom: "24px",
                width: "2px",
                backgroundColor: "#e2e8f0",
              }}
            />
          )}

          {/* User card */}
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "16px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              border: "1px solid #edf2f7",
              position: "relative",
            }}
          >
            {/* Level indicator */}
            {level > 0 && (
              <div
                style={{
                  position: "absolute",
                  left: "-28px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  backgroundColor: "#4299e1",
                  border: "2px solid white",
                  zIndex: 1,
                }}
              />
            )}

            {/* User info */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
                gap: "8px",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#ebf8ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#3182ce",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                {user.userName.charAt(0).toUpperCase()}
              </div>

              <div>
                <div
                  style={{
                    fontWeight: "600",
                    color: "#2d3748",
                  }}
                >
                  {user.userName}
                </div>
                <div
                  style={{
                    fontSize: "0.8rem",
                    color: "#718096",
                  }}
                >
                  {user.email}
                </div>
              </div>
            </div>

            {/* Stats row */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                marginTop: "12px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#ebf8ff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  color: "#3182ce",
                }}
              >
                Level {user.level}
              </div>

              <div
                style={{
                  backgroundColor: user.isActive ? "#f0fff4" : "#fff5f5",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  color: user.isActive ? "#38a169" : "#e53e3e",
                }}
              >
                {user.isActive ? "Active" : "Inactive"}
              </div>

              <div
                style={{
                  backgroundColor: "#fffaf0",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  color:
                    user.planName === "No plan active" ? "#a0aec0" : "#dd6b20",
                }}
              >
                {user.planName}
              </div>
            </div>
          </div>

          {/* Children */}
          {user.children && user.children.length > 0 && (
            <div style={{ marginTop: "12px" }}>
              <ReferralTreeDisplay tree={user.children} level={level + 1} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdminDashboard;
